export default __webpack_public_path__ + "static/media/discipline-environmental.15efa2a8.svg";